import React from 'react';
import { useAlerts } from '../../contexts/AlertContext';

/**
 * Amber "you have unacknowledged alerts" banner for the Dashboard.
 * Hidden when all alerts have been acknowledged.
 */
const AlertBanner: React.FC = () => {
  const { unackedCount, setIsBellOpen } = useAlerts();

  if (unackedCount === 0) return null;

  return (
    <div className="mb-6 flex items-center justify-between bg-amber-900/20 border border-amber-500/40 rounded-xl px-4 py-3">
      <div className="flex items-center gap-3">
        <span className="text-xl">🔔</span>
        <div>
          <p className="text-amber-300 font-semibold text-sm">
            You have {unackedCount} unacknowledged alert{unackedCount !== 1 ? 's' : ''}.
          </p>
          <p className="text-amber-400/70 text-xs mt-0.5">
            Review and acknowledge them to dismiss this banner.
          </p>
        </div>
      </div>
      <button
        onClick={() => setIsBellOpen(true)}
        className="bg-amber-500 hover:bg-amber-400 text-black font-bold text-sm px-4 py-1.5 rounded-lg transition-colors flex-shrink-0"
      >
        View →
      </button>
    </div>
  );
};

export default AlertBanner;
